import React, { useState, useEffect } from "react";
import BigTitle from "../components/BigTitle";
import { App } from "../firebase";
import { useHistory } from "react-router-dom";
import "../styles/mon-compte.scss";
import { setLanguage, getTranslation } from "firebase-error-translator";
import Title from "../components/Title";
import Adresse from "../components/address";
import { Box, Row, ColumnTow } from "../components/FooterStyles";
import UpdatePasswordView from "../components/Forms/UpdatePassword";
import UpdateUserView from "../components/Forms/UpdateUser";

import { API_URL } from "../constant";
import Popup from "../components/popup";
const MyAccount = () => {
  const [user, setUser] = useState(App.auth().currentUser);
  const history = useHistory();
  const [email, setEmail] = useState("");
  const [prenom, setPrenom] = useState("");
  const [nom, setNom] = useState("");
  const [loading, setLading] = useState(false);
  const [password, setPassword] = useState("");
  const [phone, setPhone] = useState(null);
  const [devBanner, setDevBanner] = useState(false);
  const [allCards, setCards] = useState([]);
  const [openCards, setOpenCards] = useState(false);
  const [stripeId, setCustomerId] = useState("");
  const [loadingCard, setLoadingCard] = useState("");
  const [carts, setCarts] = React.useState([]);
  const [cartsplus, setCartsPlus] = React.useState([]);
  const [oldCarts, setOldCarts] = React.useState([]);
  const [cartsOldplus, setOldCartsPlus] = React.useState([]);

  const db = App.firestore();

  const [size, setSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight,
  });
  useEffect(() => {
    const handleResize = () => {
      setSize({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    };
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  setLanguage("fr");
  App.auth().languageCode = "fr";
  const signIn = () => {
    setLading(true);
    App.auth()
      .signInWithEmailAndPassword(email, password)
      .then((res) => {
        setLading(false);
        history.push("/mon-compte#login-successful");
        //do something else with the response
      })
      .catch((err) => {
        setLading(false);
        //do something with the error
        console.log(err.code);
        // alert(getTranslation(err.code));
        alert("Identifiant invalide");
      });
  };

  const getCardsUser = async (customerId) => {
    setLoadingCard(true);
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      customerId: customerId,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API_URL + "list-method-card", requestOptions)
      .then((res) => res.json())
      .then((data) => {
        if (data.cards) {
          // console.log(data.cards.length);
          setCards(data.cards);
        } else {
          setCards([]);
        }
        setLoadingCard(false);
      })
      .catch((err) => {
        setLoadingCard(false);
        console.log(err);
        alert("Une erreur s'est produite");
      });
  };

  const delCardsUser = async (cardId, number) => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm("Supprimer cette carte **** " + number + "?")) {
      // continue
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      var raw = JSON.stringify({
        payId: cardId,
      });
      var requestOptions = {
        method: "DELETE",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };
      fetch(API_URL + "payment-method-card", requestOptions)
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          if (data.success) {
            getCardsUser(stripeId);
            alert("Carte supprimée");
          } else {
            alert("Une erreur s'est produite");
          }
        })
        .catch((err) => {
          console.log(err);
          alert("Une erreur s'est produite");
        });
    }
  };

  async function saveInfos(prenomx, nomx, phonex, finished) {
    if (prenomx || nomx) {
      db.collection("users")
        .doc(user.uid)
        .update({
          prenom: prenomx,
          nom: nomx,
          _update_At: new Date(),
        })
        .then((result) => {
          console.log("result", result);
          user.updateProfile({
            displayName: prenomx + " " + nomx,
          });

          setNom(nomx);
          setPrenom(prenomx);
          if (user && phonex && user.phoneNumber !== phonex) {
            // alert("Vos informations ont bien été modifié.");
          } else {
            alert("Vos informations ont bien été modifié.");
            finished();
          }
        })
        .catch((error) => {
          console.log("error", error);
          alert(getTranslation(error.code));
        });
    } else {
      console.log("no name or prenom");
    }
  }
  function removeAllChildNodes(parent) {
    while (parent.firstChild) {
      parent.removeChild(parent.firstChild);
    }
  }

  async function save(prenomx, nomx, phonex, finished) {
    saveInfos(prenomx, nomx, phonex, finished);
    const { currentUser: fuser } = App.auth();
    if (fuser && fuser.phoneNumber !== phonex) {
      try {
        const verifier = new App.auth.RecaptchaVerifier("recaptcha-container", {
          callback: (response) => console.log("callback", response),
          size: "invisible",
        });
        const phoneProvider = new App.auth.PhoneAuthProvider();
        const id = await phoneProvider.verifyPhoneNumber(phonex, verifier);
        const code = prompt("Veuillez entrer le code qui vous a été envoyé");
        const cred = App.auth.PhoneAuthProvider.credential(id, code);
        await fuser.updatePhoneNumber(cred);
        db.collection("users").doc(user.uid).update({
          phone: phonex,
          _update_At: new Date(),
        });
        console.log("phone number changed", id, cred, fuser);
        const container = document.querySelector("#recaptcha-container");
        removeAllChildNodes(container);
        finished();
        alert("Vos informations ont bien été modifié.");
      } catch (e) {
        const container = document.querySelector("#recaptcha-container");
        removeAllChildNodes(container);
        finished();
        console.error(e);
        if (e.code == "auth/credential-already-in-use") {
          alert(
            "Ce numéro est déjà attribué a un autre compte, contactez nous pour en savoir plus."
          );
        }
        if (e.code == "auth/too-many-requests") {
          alert(
            "Nous avons bloqué toutes les demandes de cet appareil en raison d'une activité inhabituelle. Réessayez plus tard."
          );
        } else {
          alert("Une erreur s'est produite, réessayer plus tard.");
        }

        // alert(getTranslation(e.code));
      }
    }
  }

  const logOut = () => {
    App.auth()
      .signOut()
      .then((res) => {
        history.push("/auth");
        //do something else with res
      })
      .catch((err) => {
        alert(getTranslation(err.code));
      });
  };

  const forgetPass = () => {
    let em = prompt("Quel est votre email ?");

    if (em.length > 0) {
      App.auth()
        .sendPasswordResetEmail(em)
        .then(() => {
          alert("Veuillez vérifier vos mails.");
        })
        .catch((error) => {
          alert(getTranslation(error.code));
          // ..
        });
    }
  };

  const getUserInfos = (uid) => {
    // get info user in store
    var docRef = db.collection("users").doc(uid);
    // console.log(uid);
    docRef
      .get()
      .then((doc) => {
        if (doc.exists) {
          // console.log("Document data:", doc.data());
          const { environement, nom, prenom, customerStripeId } = doc.data();

          if (
            environement === "dev" &&
            window.location.hostname === "onfleek.re"
          ) {
            //logout user
            alert(
              "Votre compte est suspendu ou n'a pas autorisation pour accèder a notre site, contactez nous pour plus d'information."
            );
            logOut();
          } else {
            if (environement === "dev") {
              setDevBanner(true);
            }
            setNom(nom);
            setPrenom(prenom);
            setCustomerId(customerStripeId);
          }
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
      })
      .catch((error) => {
        console.log("Error getting document:", error);
      });
  };

  const saveNewPassword = (
    actualPassword,
    newpassword,
    confirmPassword,
    clean
  ) => {
    // TODO(you): prompt the user to re-provide their sign-in credentials
    if (newpassword && confirmPassword && newpassword == confirmPassword) {
      App.auth()
        .signInWithEmailAndPassword(
          App.auth().currentUser.email,
          actualPassword
        )
        .then((res) => {
          // User re-authenticated.
          // alert("Les mots de passe correspondent ");
          App.auth()
            .currentUser.updatePassword(newpassword)
            .then(() => {
              // Update successful.
              alert("Mot de passe mis à jour");
              history.push("/mon-compte");
              clean();
            })
            .catch((error) => {
              // An error ocurred
              // ...
              console.log(error);
              alert(
                "Une erreur s'est produite lors de la modification, réessayer plus tard."
              );
            });
        })
        .catch((error) => {
          // An error ocurred
          console.log("error", error);

          alert("Votre mot de passe actuel ne correspond pas");
        });
    } else {
      alert("Les mots de passe sont invalide/ne correspondent pas");
    }
  };

  const sortByDate = (arr) => {
    const sorter = (a, b) => {
      return new Date(a.date).getTime() - new Date(b.date).getTime();
    };
    return arr.sort(sorter);
  };

  const getRdvs = (userId) => {
    setLading(true);
    fetch(API_URL + "rdvs", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: userId,
      }),
    })
      .then((res) => res.json())
      .then(function (response) {
        // console.log("response", response); // This will sometime be empty
        if (response.success) {
          if (response.carts) {
            //soit paid ou cancelled
            var cartso = [];
            var cartss = [];
            response.carts.forEach((cart) => {
              if (new Date(cart.date) < new Date()) {
                //fini de passer
                cartso.push(cart);
              } else {
                cartss.push(cart);
              }
            });
            if (cartso.length > 1) {
              const cartsoOrder = sortByDate(cartso);
              if (cartsoOrder.length > 4) {
                setOldCarts(cartsoOrder.slice(0, 4));
                setOldCartsPlus(cartsoOrder.slice(4, cartsoOrder.length));
              } else {
                setCarts(cartsoOrder);
              }
            } else {
              setOldCarts(cartso);
            }
            if (cartss.length > 1) {
              const cartsOrder = sortByDate(cartss);
              if (cartsOrder.length > 4) {
                setCarts(cartsOrder.slice(0, 4));
                setCartsPlus(cartsOrder.slice(4, cartsOrder.length));
              } else {
                setCarts(cartsOrder);
              }
            } else {
              setCarts(cartss);
            }
          }
          setLading(false);
        } else {
          setLading(false);
          alert(
            "Une erreur s'est produite lors de la récupération de vos rendez-vous."
          );
        }
      })
      .catch(function (error) {
        setLading(false);
        console.log("People we have an error!", error);
        alert("Une erreur s'est produite");
      });
  };

  useEffect(() => {
    setLading(true);
    App.auth().onAuthStateChanged((u) => {
      setLading(false);
      // console.log(u);
      if (!u) {
        history.push("/mon-compte#logout");
        setUser(null);
        setPhone(null);
      } else {
        setUser(u);
        setPhone(u.phoneNumber);
        getUserInfos(u.uid);
        getRdvs(u.uid);
      }
    });
    setTimeout(() => {
      setLading(false);
    }, 5000);
  }, []);

  const verifAccount = () => {
    App.auth()
      .currentUser.sendEmailVerification({
        url: window.location.origin + "/mon-compte",
      })
      .then(function (result) {
        // result.user.tenantId should be ‘TENANT_PROJECT_ID’.
        alert("Un email de vérification a été envoyé.");
      })
      .catch(function (error) {
        if (error.code != "auth/too-many-requests") {
          console.log(error);
          alert(getTranslation(error.code));
        } else {
          alert(
            "Vous avez effectué trop de demande, veuillez réessayer plus tard."
          );
        }
      });
  };

  const BlocRDVInline = ({ data }) => {
    const getDate = () => {
      var s = new Date(data.date).toLocaleDateString("fr-Fr", {
        weekday: "short",
        day: "2-digit",
        month: "short",
      });
      s +=
        " à " +
        new Date(data.date).getHours() +
        "h" +
        (new Date(data.date).getMinutes() < 10
          ? "0" + new Date(data.date).getMinutes()
          : new Date(data.date).getMinutes());

      return s.charAt(0).toUpperCase() + s.slice(1);
    };
    return (
      <div className="content-bloc-2 bloc-rdv">
        <div
          className="content-rdv"
          style={{
            justifyContent: "left",
            display: size.width > 428 ? "flex" : "inherit",
          }}
        >
          {data.professionnel && (
            <>
              <div
                class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px"
                style={{
                  marginBottom: size.width <= 428 && 11,
                  marginRight: 10,
                }}
              >
                {data.professionnel.name}
              </div>
              <p
                className="address subtitle helveticaneue-regular-normal dove-gray-16px"
                style={{ paddingBottom: size.width <= 428 && 11, marginTop: 2 }}
              >
                {data.professionnel.adresse +
                  " " +
                  data.professionnel.zipcode +
                  " " +
                  data.professionnel.city}
              </p>
            </>
          )}
        </div>
        <span class="span0 premire-prestation">{data && getDate()}</span>
        {data.prestations.map((p) => {
          return (
            <p
              class="premire-prestation"
              style={{ paddingTop: size.width > 428 && 0 }}
            >
              <span class="span0">{p.name}</span>
              <span class="helveticaneue-regular-normal dove-gray-16px">
                {" "}
                - {timeConvert(p.time)} - {(p.price / 100).toFixed(2)}€
              </span>
              {data.prestations[data.prestations.length - 1].id == p.id && (
                <>
                  {" "}
                  -{" "}
                  {data.price != 0 && (
                    <a
                      href={data.invoinceLink}
                      target="_blank"
                      style={{ cursor: "pointer", color: "#000" }}
                      className={"address"}
                    >
                      {" "}
                      Acompte versé {(data.price / 100).toFixed(2)}€
                    </a>
                  )}
                </>
              )}
            </p>
          );
        })}
        <div class="rdv-confirm">
          {data.status !== "usercancelled" ? (
            <>
              <img
                alt="check"
                class="icon-awesome-check-circle"
                src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/623c563f938d76bf44a05e3a/img/icon-awesome-check-circle-1@1x.png"
              />
              <div class="rendez-vous-termin raleway-semi-bold-eerie-black-15px">
                Rendez-vous terminé
              </div>
            </>
          ) : (
            <div class="rendez-vous-termin raleway-semi-bold-eerie-black-15px">
              Rendez-vous annulé
            </div>
          )}
        </div>
      </div>
    );
  };

  const showOldPlus = () => {
    var actual = oldCarts.length + 5;
    var all = oldCarts;
    all = all.concat(cartsOldplus);
    if (all.length > actual) {
      setOldCarts(all.slice(0, actual));
      setOldCartsPlus(all.slice(actual, all.length));
    } else {
      setOldCarts(all);
      setOldCartsPlus([]);
    }
  };

  const showPlus = () => {
    var actual = carts.length + 5;
    var all = carts;
    all = all.concat(cartsplus);
    if (all.length > actual) {
      setCarts(all.slice(0, actual));
      setCartsPlus(all.slice(actual, all.length));
    } else {
      setCarts(all);
      setCartsPlus([]);
    }
  };
  function timeConvert(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);

    if (rhours > 0) {
      return rhours + "h " + rminutes + " min";
    } else {
      return num + " min";
    }
  }
  const calHeight = (prestations) => {
    return 295 + (prestations && 18 * prestations.length) + "px";
  };

  const BlocRDV = ({ data }) => {
    const getDate = () => {
      var s = new Date(data.date).toLocaleDateString("fr-Fr", {
        weekday: "short",
        day: "2-digit",
        month: "short",
      });
      s +=
        " à " +
        new Date(data.date).getHours() +
        "h" +
        (new Date(data.date).getMinutes() < 10
          ? "0" + new Date(data.date).getMinutes()
          : new Date(data.date).getMinutes());

      return s.charAt(0).toUpperCase() + s.slice(1);
    };

    function diff_minutes() {
      const dt1 = new Date();
      const dt2 = new Date(data.date);
      var diff = (dt2.getTime() - dt1.getTime()) / 1000;
      diff /= 60;
      return Math.abs(Math.round(diff));
    }
    // 12 heures = 720 minutes
    return (
      <div className="content-bloc-2 bloc-rdv">
        <div
          className="content-sha content-rdv"
          style={{
            justifyContent: "left",
            display: size.width > 428 ? "flex" : "inherit",
          }}
        >
          <div
            className={"img-test-2"}
            style={{
              height: calHeight(data.prestations),
              maxWidth: size.width > 428 && 378,
              backgroundImage:
                data.professionnel &&
                data.professionnel.pictures[0] &&
                `url("` + data.professionnel.pictures[0] + `")`,
            }}
          />
          <div style={{ width: "100%", padding: 0 }} className="col-50">
            <div className="sub-content-rdv">
              {data.professionnel && (
                <>
                  <div
                    class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px"
                    style={{ marginBottom: size.width > 428 && 15 }}
                  >
                    {data.professionnel.name}
                  </div>
                  <Adresse
                    address={
                      data.professionnel.adresse +
                      " " +
                      data.professionnel.zipcode +
                      " " +
                      data.professionnel.city
                    }
                    style={{ paddingBottom: size.width > 428 && 5 }}
                  />
                </>
              )}
            </div>
            {size.width > 428 && <div className="divider" />}
            {data.status === "paid" ||
            data.status === "update" ||
            data.status === "usercancelled" ? (
              <div
                className="sub-content-rdv"
                style={{
                  paddingTop: size.width <= 428 && 5,
                }}
              >
                <span class="span0 premire-prestation">
                  {data && getDate()}
                </span>
                {data.prestations.map((p) => {
                  return (
                    <p
                      class="premire-prestation"
                      style={{ paddingTop: size.width > 428 && 5 }}
                    >
                      <span class="span0">{p.name}</span>
                      <span class="helveticaneue-regular-normal dove-gray-16px">
                        {" "}
                        - {timeConvert(p.time)} - {(p.price / 100).toFixed(2)}€
                      </span>
                    </p>
                  );
                })}
                <div style={{ marginTop: 20 }}>
                  {data.price && data.price != 0 ? (
                    <Adresse
                      address={
                        "Acompte de " +
                        (data.price / 100).toFixed(2) +
                        "€ versé."
                      }
                    />
                  ) : (
                    ""
                  )}
                  {data.reste && data.reste != 0 ? (
                    <Adresse
                      address={
                        "Reste à payer " +
                        (data.reste / 100).toFixed(2) +
                        "€ sur place"
                      }
                    />
                  ) : (
                    ""
                  )}
                </div>
                <div
                  style={{
                    display: size.width > 428 && "flex",
                    marginTop: 15,
                  }}
                >
                  {data.invoinceLink && (
                    <a href={data.invoinceLink} target="_blank">
                      <div
                        class="modifier-mon-rdv raleway-bold-eerie-black-15px"
                        style={{ marginRight: size.width > 428 && 30 }}
                      >
                        Facture
                      </div>
                    </a>
                  )}

                  {data.status === "usercancelled" ||
                  data.status === "update" ? (
                    <div
                      class=" raleway-bold-eerie-black-15px"
                      style={{ marginTop: 18 }}
                    >
                      {data.status === "usercancelled"
                        ? "Vous avez annulé ce rendez-vous"
                        : "Vous avez déjà modifié ce rendez-vous "}
                    </div>
                  ) : (
                    <>
                      {diff_minutes() > 720 && (
                        <>
                          <a
                            onClick={() => {
                              history.push({
                                pathname: "/editrdv/" + data.id,
                                state: data.professionnel,
                              });
                            }}
                          >
                            <div class="modifier-mon-rdv raleway-bold-eerie-black-15px">
                              Modifier mon RDV
                            </div>
                          </a>
                          <Popup type="promptrdvcancel" withup={data} />
                        </>
                      )}
                    </>
                  )}
                </div>
              </div>
            ) : (
              <div
                className="sub-content-rdv"
                style={{
                  paddingTop: size.width <= 428 && 5,
                  paddingBottom: 40,
                }}
              >
                <Adresse address="Paiement annulé" />
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };
  const MyRDV = () => {
    return (
      <div>
        {devBanner && (
          <>
            <p
              className="content-sha"
              style={{
                padding: 10,
                margin: 30,
                background: "pink",
                borderRadius: 10,
                color: "#000",
                fontSize: 12,
                maxWidth: 784,
                margin: "30px auto",
              }}
            >
              Vous êtes sur le serveur de développement toutes les données de ce
              compte sont en mode développement.
              <br />
              Vous ne pourrez pas accèder au serveur de production avec ce
              compte.
              <br />
              <br />
              <i style={{ fontStyle: "italic" }}>
                Cette information n'est visible que sur les environements de
                développement.
              </i>
            </p>
          </>
        )}

        <Title title="Mes rendez vous" />
        {!loading && carts.length === 0 && (
          <div className="content-bloc-2">
            <div
              className="content-sha"
              style={{
                padding: size.width > 428 ? "10px 50px" : "35px 20px ",
                display: size.width > 428 ? "flex" : "inherit",
              }}
            >
              <p className="content-p ">
                Vous n’avez pas encore de rendez-vous
              </p>
              <button
                class="bouton-plein border-1px-dove-gray"
                style={{
                  margin: size.width <= 428 && "auto",
                  height: 55,
                  border: "none",
                }}
                onClick={() => {
                  history.push("/");
                }}
              >
                <div class="prendre-rdv raleway-semi-bold-white-18px">
                  Prendre RDV
                </div>
              </button>
            </div>
          </div>
        )}
        {loading && (
          <div style={{ margin: "auto", padding: "60px 0px", width: 55 }}>
            <div class="loader" />
          </div>
        )}

        {carts &&
          carts.map((cart) => {
            return <BlocRDV data={cart} key={cart.id} />;
          })}
        {cartsplus.length > 0 && (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            onClick={() => {
              showPlus();
            }}
            style={{
              cursor: "pointer",
            }}
          >
            <p
              className="content-p"
              style={{
                textAlign: "center",
                color: "gray",
                marginTop: 30,
                marginBottom: 30,
              }}
            >
              Afficher plus de rendez-vous
            </p>
          </a>
        )}
        {oldCarts &&
          oldCarts.map((cart) => {
            return <BlocRDVInline data={cart} key={cart.id} />;
          })}
        {cartsOldplus.length > 0 && (
          // eslint-disable-next-line jsx-a11y/anchor-is-valid
          <a
            onClick={() => {
              showOldPlus();
            }}
            style={{
              cursor: "pointer",
            }}
          >
            <p
              className="content-p"
              style={{
                textAlign: "center",
                color: "gray",
                marginTop: 30,
                marginBottom: 30,
              }}
            >
              Afficher plus de rendez-vous terminé
            </p>
          </a>
        )}
      </div>
    );
  };

  const MyInfos = () => {
    return (
      <>
        <Title title="Mes informations" />
        <div className="content-bloc-2">
          <div
            className="content-sha"
            style={{
              padding: size.width > 428 ? "10px 50px" : "35px 20px ",
              display: size.width > 428 ? "flex" : "inherit",
            }}
          >
            <UpdateUserView
              user={user}
              prenom={prenom}
              nom={nom}
              phone={phone}
              saveUser={save}
            />
          </div>
        </div>
      </>
    );
  };

  const UpdatePassword = () => {
    return (
      <>
        <Title title="Modifier mon mot de passe" />

        <div className="content-bloc-2">
          <div
            className="content-sha"
            style={{
              padding: size.width > 428 ? "10px 50px" : "35px 20px ",
              display: size.width > 428 ? "flex" : "inherit",
            }}
          >
            <UpdatePasswordView saveNewPassword={saveNewPassword} />
          </div>
        </div>
      </>
    );
  };

  const UserIsLogin = () => {
    return (
      <div>
        {/* {user && !user.emailVerified && (
          <div
            className="content-bloc-2"
            style={{
              marginTop: 60,
            }}
          >
            <div
              className="content-sha"
              style={{
                padding: size.width > 428 ? "10px 50px" : "35px 20px ",
                display: size.width > 428 ? "flex" : "inherit",
              }}
            >
              <p className="content-p ">
                Vous n’avez pas encore vérifié votre compte
              </p>
              <button
                class="bouton-plein border-1px-dove-gray"
                onClick={verifAccount}
                style={{
                  maxWidth: "301px",
                  margin: size.width <= 428 && "auto",
                }}
              >
                <div
                  class="prendre-rdv raleway-semi-bold-white-18px"
                  style={{
                    maxWidth: "301px",
                    fontSize: 12,
                  }}
                >
                  Envoyé un nouvel email de vérification
                </div>
              </button>
            </div>
          </div>
        )} */}
        <>
          <MyRDV />
          <MyInfos />
          <UpdatePassword />
          <Title title="Mes moyens de paiement" />

          <div className="content-bloc-2">
            <div
              className="content-sha"
              style={{
                padding: size.width > 428 ? "10px 50px" : "35px 20px ",
                display: size.width > 428 ? "flex" : "inherit",
              }}
            >
              <Box
                style={{
                  backgroundColor: "#fff",
                  padding: size.width <= 428 ? 0 : " 45px 0px",
                }}
              >
                <div
                  style={{
                    borderRadius: 10,
                    padding: "13px 20px",
                    border: "1px solid black",
                  }}
                >
                  <a
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignContent: "center",
                    }}
                    onClick={() => {
                      setOpenCards(!openCards);
                      if (!openCards && stripeId && allCards.length == 0) {
                        getCardsUser(stripeId);
                      }
                    }}
                  >
                    <div class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px">
                      Mes cartes bancaire
                    </div>

                    <img
                      src={process.env.PUBLIC_URL + "/down.faq.png"}
                      alt="down.faq"
                      style={{
                        transform: !openCards
                          ? "rotate(0deg)"
                          : "rotate(180deg)",
                        height: size.width > 700 ? 16 : 12,
                        width: size.width > 700 ? 24.66 : 20,
                        alignSelf: "center",
                      }}
                    />
                  </a>
                  {openCards && (
                    <>
                      <Row>
                        <p className="subtitle" style={{ paddingBottom: 20 }}>
                          {allCards &&
                            allCards.length == 0 &&
                            !loadingCard &&
                            "Vous n'avez actuellement aucune carte"}
                          {loadingCard && "Chargement..."}
                          {/* // : "Vous avez actuellement " + // allCards.length
                            + // " carte" + // (allCards.length > 1 ? "s" : "")} */}
                        </p>
                      </Row>
                      <div className="row">
                        {allCards.map((a) => (
                          <div
                            className="col-50"
                            style={{
                              paddingRight: 37,
                              marginBottom: 15,
                              maxWidth: 298,
                            }}
                          >
                            {/* {console.log(a)} */}
                            {/* <img>{a.card.brand}</img> */}
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <div
                                style={{
                                  // backgroundColor: "red",
                                  width: 27.34,
                                  height: 21.27,
                                  marginRight: 10,
                                }}
                              >
                                <img
                                  alt=""
                                  src={a.card.brand + ".png"}
                                  style={{
                                    maxWidth: 27.34,
                                    height: 21.27,
                                  }}
                                />
                              </div>
                              <span className="roboto-normal-eerie-black-20px">
                                **** **** **** {a.card.last4}
                              </span>
                              <a
                                onClick={() => delCardsUser(a.id, a.card.last4)}
                                href
                              >
                                <div
                                  style={{
                                    // backgroundColor: "red",
                                    width: 27.34,
                                    height: 21.27,
                                    marginLeft: 15,
                                  }}
                                >
                                  <img
                                    alt=""
                                    src={"trash.png"}
                                    style={{
                                      display: "flex",
                                      marginLeft: "auto",
                                      width: 16.77,
                                      height: 19.16,
                                    }}
                                  />
                                </div>
                              </a>
                            </div>

                            <div
                              style={{
                                marginTop: 9,
                                backgroundColor: "#BFBFBF",
                                width: "100%",
                                height: 1,
                              }}
                            />
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>
                <Row>
                  <ColumnTow>
                    <button
                      class="bouton-plein border-1px-dove-gray"
                      style={{
                        height: 55,
                        marginTop: "20px",
                        maxWidth: 332,
                      }}
                      onClick={() => {
                        history.push("/add-method-card");
                      }}
                    >
                      <div class="prendre-rdv raleway-semi-bold-white-18px">
                        Ajouter une carte bancaire
                      </div>
                    </button>
                  </ColumnTow>
                </Row>
              </Box>
            </div>
          </div>
        </>

        <div style={{ margin: "auto", padding: "60px 0px", width: 196 }}>
          <a onClick={logOut} href>
            <div
              class=" border-2px-eerie-black"
              style={{
                cursor: "pointer",
                borderRadius: 10,
                display: "flex",
                height: 55,
                width: 196,
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div class="sinscrire raleway-bold-eerie-black-14px" style={{}}>
                Se déconnecter
              </div>
            </div>
          </a>
        </div>
      </div>
    );
  };

  return (
    <>
      <BigTitle title="Mon compte" />
      {loading ? (
        <div style={{ margin: "auto", padding: "60px 0px", width: 55 }}>
          <div class="loader" />
        </div>
      ) : (
        <>
          {user ? (
            <UserIsLogin />
          ) : (
            <div class="login-master">
              <div class="vous-avez-dj-un-compte raleway-bold-eerie-black-20px">
                Vous avez déjà un compte ?
              </div>
              <div class="overlap-group-login2 content-sha ">
                <div class="groupe-27 parapgrah">
                  <div class="groupe-2">
                    <input
                      value={email}
                      onChange={(e) => setEmail(e.currentTarget.value)}
                      type={"email"}
                      class="email parapgrah"
                      name="email01"
                      placeholder="Email"
                    />
                    <img
                      alt=""
                      class="lignelogin-1"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6232bd89c33354ba7bff5780/img/ligne-1-10@1x.png"
                    />
                  </div>
                  <div class="groupe-2-1">
                    <input
                      value={password}
                      onChange={(e) => setPassword(e.currentTarget.value)}
                      type={"password"}
                      class="mot-de-passe parapgrah"
                      name="mot-de-passe01"
                      placeholder="Mot de passe"
                    />
                    <img
                      alt=""
                      class="lignelogin-1"
                      src="https://anima-uploads.s3.amazonaws.com/projects/6232bd12a610d88f478643a7/releases/6232bd89c33354ba7bff5780/img/ligne-1-10@1x.png"
                    />
                  </div>
                  {/* <div class="overlap-group-login"> */}
                  <button
                    class="btn-valider"
                    onClick={signIn}
                    style={{ border: "none", marginTop: 20 }}
                  >
                    <div class="valider raleway-semi-bold-white-18px">
                      Valider
                    </div>
                  </button>
                  <p class="mot-de-passe-oubli" onClick={forgetPass}>
                    Mot de passe oublié ?
                  </p>
                  {/* </div> */}
                </div>
              </div>
              <div class="cest-votre-premire-fois raleway-bold-eerie-black-20px">
                C’est votre première fois ?
              </div>
              <div class="overlap-group-login2 content-sha">
                <a href="/sign-in">
                  <div class="bouton-stroke border-2px-eerie-black">
                    <div class="sinscrire raleway-bold-eerie-black-14px">
                      S’inscrire
                    </div>
                  </div>
                </a>
              </div>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default MyAccount;
